// extracted by mini-css-extract-plugin
module.exports = {"offer":"styles-module--offer--2l8S6","idea":"styles-module--idea--KmTSy","content":"styles-module--content--1mS3L"};